import {NgModule} from '@angular/core';
import {LuggageUnitPipe} from "./luggage-unit.pipe";


@NgModule({
    imports: [],
    exports: [LuggageUnitPipe],
    declarations: [
        LuggageUnitPipe
    ],
    providers: [LuggageUnitPipe]
})
export class LuggageUnitModule {
}
